import { Component, OnInit } from '@angular/core';
import { Constant } from '../../constant'
import { GlobalService } from '../services/global.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-failed',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.css']
})
export class FailedComponent implements OnInit {

  errorMsg:any;
  isSuccess:boolean = false;

  constructor(private service: GlobalService,private spinner: NgxSpinnerService,) { }

  ngOnInit() {
    if(localStorage.getItem('razorpayError')){
      this.errorMsg = JSON.parse(localStorage.getItem('razorpayError'));
      console.log(this.errorMsg);
      this.isSuccess = true;
      this.saveFailedRes();
    }
  }

   // console.log('code:-',this.errorMsg.error.code);
    // console.log('desc:-',this.errorMsg.error.description);
    // console.log('payment ID:',this.errorMsg.error.metadata.payment_id);
    // console.log('order ID:',this.errorMsg.error.metadata.order_id);
    
    saveFailedRes(){
      let url = Constant.saveMandateSign;
      if(this.errorMsg){
        let reqObj = {
          "razorpay_PaymentId": this.errorMsg.error.metadata.payment_id,
          "razorpay_orderId": this.errorMsg.error.metadata.order_id,
          "razorpay_signiture":""
      }
          this.service.PostService(url, reqObj).subscribe(response => {
              // add loader here 
          })
      }
    }


  ngOnDestroy() {
    localStorage.clear();
  }
}
